








































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import RenderModal from "@/components/Shared/RenderModal.vue";
import Address from "@/api/Address";
import ProvinceService from "@/service/ProvinceService";
import {SelectBoxItem} from "@/api/SelectBoxItem";
import CityService from "@/service/CityService";
import AddressesFormGoogleMapsView from "@/components/Dashboard/Address/AddressesFormGoogleMapsView.vue";
import Customer from "@/api/Customer";
import CustomerService from "@/service/CustomerService";
import AddressService from "@/service/AddressService";

@Component({
  components: {AddressesFormGoogleMapsView, RenderModal}
})
export default class AddressesFormView extends Vue {
  @Prop() address!: Address;

  private provinceList = new Array<SelectBoxItem>();
  private cityList = new Array<SelectBoxItem>();
  private addressToEdit = new Address();
  private showMap = true;
  private modalTitle = "آدرس جدید";
  private formError: string | null = null;
  private showReceiveSelf = true;
  private currentCustomer = new Customer();

  async mounted() {
    if (this.address) {
      this.addressToEdit = new Address(this.address);
      if (this.addressToEdit.addressId) {
        this.modalTitle = "ویرایش آدرس";
        this.showReceiveSelf = false;
      }
    }
    this.currentCustomer = await this.getCurrentCustomer();
    await this.getProvincesList();
    await this.getCitiesList();
  }

  closeForm(saved = false) {
    this.$emit('close-address-form', {saved: saved});
  }

  saveMapLocation(position: any) {
    this.addressToEdit.latitude = position.latitude;
    this.addressToEdit.longitude = position.longitude;
    this.showMap = false;
  }

  skipMapLocation() {
    this.showMap = false;
  }

  showMapClicked() {
    this.showMap = true;
  }

  async submitAddress() {
    const response = await AddressService.saveAddress(this.addressToEdit);
    if (response.success) {
      this.formError = null;
      this.closeForm(true);
    } else {
      this.formError = response.message;
    }
  }

  async getProvincesList() {
    this.provinceList = await ProvinceService.getProvinces();
  }

  async getCitiesList() {
    this.cityList = new Array<SelectBoxItem>();
    if (this.addressToEdit.provinceId) {
      this.cityList = await CityService.getCities(this.addressToEdit.provinceId);
    }
  }

  async getCurrentCustomer(): Promise<Customer> {
    return await CustomerService.getCurrentCustomer();
  }

  @Watch('addressToEdit.phone')
  onPhoneChanged(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      const formattedValue = newValue.replace('-', '');
      if(formattedValue.length > 3) {
        const fv = formattedValue.slice(0, 3) + "-" + formattedValue.slice(3);
        this.addressToEdit.phone = fv;
      }
    }
  }

  @Watch('addressToEdit.provinceId')
  onProvinceChanged(newValue: number, oldValue: number) {
    if (newValue !== oldValue) {
      this.getCitiesList();
      if (oldValue) {
        this.addressToEdit.city = null;
      }
    }
  }

  @Watch('addressToEdit.receiveSelf')
  onReceiveSelfChanged(newValue: boolean, oldValue: boolean) {
    if (newValue !== oldValue) {
      if (newValue) {
        // this.addressToEdit.city = null;
        // const customer = await this.getCurrentCustomer();
        this.addressToEdit.firstname = this.currentCustomer.firstname;
        this.addressToEdit.lastname = this.currentCustomer.lastname;
        this.addressToEdit.mobile = this.currentCustomer.mobile;
        this.addressToEdit.nationalCode = this.currentCustomer.nationalCode;
      } else {
        this.addressToEdit.firstname = "";
        this.addressToEdit.lastname = "";
        this.addressToEdit.mobile = "";
        this.addressToEdit.nationalCode = "";
      }
    }
  }
}
